import styled from 'styled-components'
import { Row } from 'react-bootstrap'

export const Container = styled(Row)`
  margin-bottom: 24px;
`
